var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulbOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 36V33.75C29.0001 31.0312 31.9569 28.4597 33.8751 26.625C36.5788 24.0403 38.0001 20.5678 38.0001 16.5C38.0001 8.99999 32.0254 2.99999 24.5001 2.99999C22.7258 2.99504 20.9681 3.34085 19.328 4.01754C17.6878 4.69422 16.1977 5.68844 14.9431 6.94301C13.6885 8.19759 12.6943 9.68779 12.0176 11.3279C11.3409 12.968 10.9951 14.7258 11.0001 16.5C11.0001 20.4225 12.4822 24.1303 15.1251 26.625C17.0329 28.4259 20.0001 31.0031 20.0001 33.75V36M21.5001 45H27.5001M20.0001 40.5H29.0001M24.5001 36V24",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 22.5C28.0625 22.5 26.0459 24 24.5 24C22.9541 24 20.9375 22.5 20.9375 22.5",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbOutline);
export default __webpack_public_path__ + "static/media/bulb-outline.8676e71072e83e432b72002ed67f3d5f.svg";
export { ForwardRef as ReactComponent };